import { Navigate, Outlet } from "react-router-dom";

const LoginRoute = (props) => {
  const { children, redirectTo="/", isAuthenticated } = props;
  return (
    !isAuthenticated ? (children ? children : <Outlet />) : <Navigate to={redirectTo} />
  );
};

export default LoginRoute;